import React from "react";

const AssetHeader = () => {
  return <div className="pool-header-container ">All Asset</div>;
};

export default AssetHeader;
